var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout-icon",
    d: "M30.6,31.7,24.387,37.88a2.711,2.711,0,1,0,3.835,3.834l10.8-10.8a2.791,2.791,0,0,0,0-3.834l-10.8-10.8a2.711,2.711,0,1,0-3.835,3.834L30.6,26.3H4.7a2.7,2.7,0,1,0,0,5.4ZM29.005,2A27.006,27.006,0,0,0,4.7,16.984a2.717,2.717,0,0,0,4.861,2.43,21.708,21.708,0,1,1,.108,19.168,2.717,2.717,0,0,0-4.861,2.43A27,27,0,1,0,29.005,2Z",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.71a57d6baeda2349d133fcb7a4511a1d.svg";
export { ForwardRef as ReactComponent };